"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepBuilder = void 0;
const StepRouter_1 = require("./StepRouter");
const TabViewController_1 = require("../ribs/view/TabViewController");
class StepBuilder {
    constructor(interactor, bodyViewController, config, childBuilder) {
        this.interactor = interactor;
        this.bodyViewController = bodyViewController;
        this.childBuilder = childBuilder;
        this.id = config.id;
        this.canCancel = config.canCancel;
        this.tabViewController = new TabViewController_1.TabViewController({ title: config.tabTitle });
    }
    build() {
        return __awaiter(this, void 0, void 0, function* () {
            const router = new StepRouter_1.StepRouter(this.interactor, this.bodyViewController, this.childBuilder);
            return {
                router,
                actionable: this.interactor
            };
        });
    }
}
exports.StepBuilder = StepBuilder;
//# sourceMappingURL=StepBuilder.js.map